<div class="d-flex">
    <mat-form-field class="flex-grow-1">
        <input matInput type="text" [ngModel]="fileName" (click)="onButtonClick()" disabled />
    </mat-form-field>

    <span class="align-self-center upload-button">
        <input #input class="visually-hidden" [id]="inputId" type="file" [accept]="fileAccept"
            (change)="fileChangeEvent($event.target.files)" />

        <button mat-raised-button color="warn" class="btn-supp" *ngIf="file !== null" (click)="onButtonSuppClick()"
            aria-label="Supprimer le fichier">
            <fa-icon [icon]="faTrash"></fa-icon>
        </button>

        <button mat-raised-button color="primary"
            (click)="onButtonClick()">{{texteService.getTexte('BTN_PARCOURIR')}}</button>
    </span>
</div>
